import React from 'react';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';

const store = configureStore({
    reducer: (state) => state,
    preloadedState: {}
});

/**
 * A Redux Provider with an empty state.
 * @param {*} props
 * @returns
 */
export const EmptyStateProvider = ({ children }) => (
    <Provider store={store}>{children}</Provider>
);
